import { WidgetBlockToViewBlockHoC, WidgetBlockWrapper } from '../../state-management';
import prepareWidgetblockMigrationScripts from '../../utils/prepareWidgetblockMigrationScripts';
import IWidgetBlock from '../types/IWidgetBlock';
import DataTable from './DataTable';
import reducer from './reducer';
import defaultState from './defaultState';
import stateMigrationScripts from './stateMigrationScripts/stateMigrationScripts';
import { DataTableConfigBlockState, DataTableState } from './types';
import WidgetConfigurator from './WidgetConfigurator/WidgetConfigurator';

const WidgetBlock: IWidgetBlock<DataTableConfigBlockState, DataTableState> = {
    label: 'Data Table',
    type: 'dataTable',
    mimeTypes: ['application/vnd.metocean.cf+json'],
    dataStructures: ['timeseries/point2d'],
    defaultState,
    reducer,
    widgetBlock: WidgetBlockWrapper(DataTable),
    render: WidgetBlockToViewBlockHoC(reducer, DataTable),
    widgetConfigurator: WidgetConfigurator,
    widgetComponent: DataTable,
    migrateState: prepareWidgetblockMigrationScripts(stateMigrationScripts),
};

export default WidgetBlock;
